import ToastMessage from "../component/ToastMessage.svelte";

export function showToast({ title = "", subtitle = "", kind = "info", timeout = 3000 } = {}) {
  const toast = new ToastMessage({
    target: document.body,
    props: { title, subtitle, kind, timeout }
  });

  setTimeout(() => {
    toast.$destroy();
  }, timeout + 300); 

  return toast;
}